<template>
  <div class="pir-rail-stack">
    <div class="pir-rail-card pir-rail-hero">
      <div class="pir-rail-eyebrow">DF สุทธิที่จะได้รับ</div>
      <div class="pir-rail-net">
        <span class="pir-rail-net-num">{{ formatNumber(netDf) }}</span>
        <span class="pir-rail-net-cur">฿</span>
      </div>
      <div class="pir-rail-net-sub">
        หลังหักค่าแลป
        <template v-if="isAfterCutoff">และค่าธรรมเนียม</template>
      </div>
    </div>

    <div class="pir-rail-card">
      <div class="pir-rail-card-title">การคำนวณ</div>
      <div class="pir-rail-row">
        <span>รายได้ DF</span>
        <b class="df">{{ formatNumber(isAfterCutoff ? dfByPaymentSummary.df : total.paidDf) }}</b>
      </div>
      <template v-if="isAfterCutoff && dfByPaymentSummary.feeAmount">
        <div class="pir-rail-row dim">
          <span>− ค่าธรรมเนียม</span>
          <b class="minus">−{{ formatNumber(dfByPaymentSummary.feeAmount) }}</b>
        </div>
        <div class="pir-rail-row">
          <span>DF หลังหักค่าธรรมเนียม</span>
          <b>{{ formatNumber(dfByPaymentSummary.netDf) }}</b>
        </div>
      </template>
      <div class="pir-rail-row dim">
        <span>− ค่าแลป</span>
        <b class="minus">−{{ formatNumber(total.labDf) }}</b>
      </div>
      <div v-if="reportSetting.isDeducted" class="pir-rail-row dim">
        <span>− หักค่าใช้จ่าย 10%</span>
        <b class="minus">−{{ formatNumber(deductDfAmount) }}</b>
      </div>
      <div class="pir-rail-divider"></div>
      <div class="pir-rail-row total">
        <span>รับสุทธิ</span>
        <b>{{ formatNumber(netDf) }}</b>
      </div>
      <div class="pir-rail-deduct">
        <b-form-checkbox
          :checked="reportSetting.isDeducted"
          switch
          @change="onDeductChange"
        >
          หักค่าใช้จ่าย 10% ตามสัญญาแพทย์
        </b-form-checkbox>
      </div>
    </div>

    <div v-if="byPaymentBars.length" class="pir-rail-card">
      <div class="pir-rail-card-title">DF ตามวิธีชำระ</div>
      <div
        v-for="(p, idx) in byPaymentBars"
        :key="idx"
        class="pir-rail-paybar"
      >
        <div class="pir-rail-paybar-head">
          <span>{{ p.name }}</span>
          <b>{{ formatNumber(p.df) }}</b>
        </div>
        <div class="pir-rail-paybar-track">
          <div
            class="pir-rail-paybar-fill"
            :style="{ width: p.pct + '%' }"
          ></div>
        </div>
      </div>
    </div>

    <div class="pir-rail-card pir-rail-meta">
      <div>
        <span>วันทำงาน</span>
        <b>{{ workingDays }}</b>
      </div>
      <div>
        <span>คนไข้</span>
        <b>{{ uniquePatientCount }}</b>
      </div>
      <div>
        <span>เฉลี่ย/วัน</span>
        <b>{{ formatNumber(avgPerDay) }}</b>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PersonalIncomeRailSummary",
  props: {
    netDf: { type: Number, default: 0 },
    isAfterCutoff: { type: Boolean, default: false },
    dfByPaymentSummary: {
      type: Object,
      default: () => ({ df: 0, feeAmount: 0, netDf: 0 }),
    },
    total: {
      type: Object,
      default: () => ({ paidDf: 0, labDf: 0 }),
    },
    reportSetting: {
      type: Object,
      default: () => ({ isDeducted: false }),
    },
    deductDfAmount: { type: Number, default: 0 },
    byPaymentBars: { type: Array, default: () => [] },
    workingDays: { type: Number, default: 0 },
    uniquePatientCount: { type: Number, default: 0 },
    avgPerDay: { type: Number, default: 0 },
  },
  methods: {
    formatNumber(num) {
      if (num === null || num === undefined) return "-";
      return num.toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    onDeductChange(value) {
      this.$emit("updateIsDeducted", value);
    },
  },
};
</script>
